export default __webpack_public_path__ + "static/media/Notifications11.ba8d6112.svg";